export enum BackgroundColor {
  DEFAULT = 'default',
  INHERIT = 'inherit',
}

export enum HoverColor {
  NONE = 'none',
  MID = 'mid',
  DARK = 'dark',
  BLUE = 'blue',
}

export enum CheckboxCardSelectedColor {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export enum CheckboxCardPadding {
  MID = 'mid',
  SMALL = 'small',
  NONE = 'none',
}

export enum CheckboxAlignment {
  TOP = 'top',
  CENTER = 'center',
  BOTTOM = 'bottom',
}
